import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { VideoPlaylist } from './types'

export const CREATE_VIDEO_PLAYLIST: TypedDocumentNode<
  { createVideoPlaylist: VideoPlaylist },
  {
    client_id: string
    application_id: string
    name: string
    description?: string | null
    observations?: string | null
  }
> = gql`
  mutation CreateVideoPlaylist($client_id: ID!, $application_id: ID!, $name: String!, $description: String, $observations: String) {
    createVideoPlaylist(client_id: $client_id, application_id: $application_id, name: $name, description: $description, observations: $observations) {
      id client_id application_id name description observations synchronized_at created_at updated_at
    }
  }
`

export const UPDATE_VIDEO_PLAYLIST: TypedDocumentNode<
  { updateVideoPlaylist: VideoPlaylist },
  {
    id: string
    name?: string
    description?: string | null
    observations?: string | null
  }
> = gql`
  mutation UpdateVideoPlaylist($id: ID!, $name: String, $description: String, $observations: String) {
    updateVideoPlaylist(id: $id, name: $name, description: $description, observations: $observations) {
      id client_id application_id name description observations synchronized_at created_at updated_at
    }
  }
`

export const DELETE_VIDEO_PLAYLIST: TypedDocumentNode<
  { deleteVideoPlaylist: boolean },
  { id: string }
> = gql`
  mutation DeleteVideoPlaylist($id: ID!) {
    deleteVideoPlaylist(id: $id)
  }
`
